var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showoff
    ? _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showoff, title: "一键铺品", width: "500px" },
          on: {
            "update:visible": function ($event) {
              _vm.showoff = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tip" }, [
            _vm._v("添加为供应链商品，同时铺货到以下勾选铺货渠道"),
          ]),
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.typeVale,
                callback: function ($$v) {
                  _vm.typeVale = $$v
                },
                expression: "typeVale",
              },
            },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-row",
                    { staticStyle: { padding: "6px 0" } },
                    [
                      _c("el-checkbox", { attrs: { label: 1, disabled: "" } }, [
                        _vm._v("农博优选"),
                      ]),
                      _c(
                        "div",
                        { attrs: { "aria-hidden": true } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.isYXOnSale,
                                callback: function ($$v) {
                                  _vm.isYXOnSale = $$v
                                },
                                expression: "isYXOnSale",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上架"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下架"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "6px 0" } },
                    [
                      _c("el-checkbox", { attrs: { label: 2 } }, [
                        _vm._v("渠道选品中心"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "6px 0" } },
                    [
                      _c("el-checkbox", { attrs: { label: 3 } }, [
                        _vm._v("ERP"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "6px 0" } },
                    [
                      _c("el-checkbox", { attrs: { label: 4 } }, [
                        _vm._v("中国土特产"),
                      ]),
                      _c(
                        "div",
                        {
                          attrs: {
                            "aria-hidden": _vm.isTtcOnSaleDisabled
                              ? "true"
                              : "false",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isTtcOnSaleDisabled },
                              model: {
                                value: _vm.isTtcOnSale,
                                callback: function ($$v) {
                                  _vm.isTtcOnSale = $$v
                                },
                                expression: "isTtcOnSale",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上架"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下架"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "24px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.submitBtn },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.close } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }